/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AdmissionStatus } from './AdmissionStatus';
import {
    AdmissionStatusFromJSON,
    AdmissionStatusFromJSONTyped,
    AdmissionStatusToJSON,
} from './AdmissionStatus';
import type { CreateLeadInfoRequest } from './CreateLeadInfoRequest';
import {
    CreateLeadInfoRequestFromJSON,
    CreateLeadInfoRequestFromJSONTyped,
    CreateLeadInfoRequestToJSON,
} from './CreateLeadInfoRequest';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientToJSON,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatus } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatus';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusToJSON,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatus';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistToJSON,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist';
import type { FindAllSourceTags200ResponseDataInner } from './FindAllSourceTags200ResponseDataInner';
import {
    FindAllSourceTags200ResponseDataInnerFromJSON,
    FindAllSourceTags200ResponseDataInnerFromJSONTyped,
    FindAllSourceTags200ResponseDataInnerToJSON,
} from './FindAllSourceTags200ResponseDataInner';

/**
 * 
 * @export
 * @interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead
 */
export interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead {
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead
     */
    lead_received_date?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead
     */
    source_name?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead
     */
    status_id?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead
     */
    connector?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadConnectorEnum;
    /**
     * 
     * @type {FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatus}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead
     */
    status?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatus;
    /**
     * 
     * @type {FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead
     */
    waitlist?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist;
    /**
     * 
     * @type {AdmissionStatus}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead
     */
    admission_status?: AdmissionStatus;
    /**
     * 
     * @type {CreateLeadInfoRequest}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead
     */
    screener_lead_info?: CreateLeadInfoRequest;
    /**
     * 
     * @type {FindAllSourceTags200ResponseDataInner}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead
     */
    facility?: FindAllSourceTags200ResponseDataInner;
    /**
     * 
     * @type {FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead
     */
    external_ehr_patient?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient;
}


/**
 * @export
 */
export const FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadConnectorEnum = {
    Aida: 'Aida',
    Aidin: 'Aidin',
    Ensocare: 'Ensocare',
    EnsocareVa: 'Ensocare VA',
    EpicCareLink: 'EpicCare Link',
    EpicCareLinkAlbanyMed: 'EpicCare Link Albany Med',
    EpicCareLinkAllinaHealth: 'EpicCare Link Allina Health',
    EpicCareLinkAsante: 'EpicCare Link Asante',
    EpicCareLinkAscension: 'EpicCare Link Ascension',
    EpicCareLinkAscensionWi: 'EpicCare Link Ascension WI',
    EpicCareLinkAspirusHealth: 'EpicCare Link Aspirus Health',
    EpicCareLinkAtriumHealth: 'EpicCare Link Atrium Health',
    EpicCareLinkBaptistHealth: 'EpicCare Link Baptist Health',
    EpicCareLinkBaptistOneCare: 'EpicCare Link Baptist One Care',
    EpicCareLinkBenefisHealthSystem: 'EpicCare Link Benefis Health System',
    EpicCareLinkBaylorScottWhiteHealth: 'EpicCare Link Baylor Scott & White Health',
    EpicCareLinkBonSecoursMercyHealth: 'EpicCare Link Bon Secours Mercy Health',
    EpicCareLinkBostonMedicalCenter: 'EpicCare Link Boston Medical Center',
    EpicCareLinkBronsonHealthcare: 'EpicCare Link Bronson Healthcare',
    EpicCareLinkBryanHealth: 'EpicCare Link Bryan Health',
    EpicCareLinkBsaHospital: 'EpicCare Link BSA Hospital',
    EpicCareLinkCapeCodHealthcare: 'EpicCare Link Cape Cod Healthcare',
    EpicCareLinkCaroMont: 'EpicCare Link CaroMont',
    EpicCareLinkCarolinaEast: 'EpicCare Link Carolina East',
    EpicCareLinkErlanger: 'EpicCare Link Erlanger',
    EpicCareLinkCentraCare: 'EpicCare Link CentraCare',
    EpicCareLinkChristusHealth: 'EpicCare Link CHRISTUS Health',
    EpicCareLinkConeHealth: 'EpicCare Link Cone Health',
    EpicCareLinkCovenantHealthCare: 'EpicCare Link Covenant HealthCare',
    EpicCareLinkDeaconess: 'EpicCare Link Deaconess',
    EpicCareLinkDenverHealth: 'EpicCare Link Denver Health',
    EpicCareLinkDukeHealth: 'EpicCare Link Duke Health',
    EpicCareLinkEcuHealth: 'EpicCare Link ECU Health',
    EpicCareLinkElCaminoHealth: 'EpicCare Link El Camino Health',
    EpicCareLinkEnloeHealth: 'EpicCare Link Enloe Health',
    EpicCareLinkFirstHealth: 'EpicCare Link FirstHealth',
    EpicCareLinkFmolhsCareConnect: 'EpicCare Link FMOLHS CareConnect',
    EpicCareLinkSelectMedical: 'EpicCare Link Select Medical',
    EpicCareLinkParkview: 'EpicCare Link Parkview',
    EpicCareLinkGenesisHealthcareSystem: 'EpicCare Link Genesis Healthcare System',
    EpicCareLinkHartfordHealthCare: 'EpicCare Link Hartford HealthCare',
    EpicCareLinkHackensackMeridianHealth: 'EpicCare Link Hackensack Meridian Health',
    EpicCareLinkHealthPartners: 'EpicCare Link HealthPartners',
    EpicCareLinkHealtheConnection: 'EpicCare Link HealtheConnection',
    EpicCareLinkHennepinCountyMedicalCenter: 'EpicCare Link Hennepin County Medical Center',
    EpicCareLinkHillcrestHealthCareSystem: 'EpicCare Link Hillcrest HealthCare System',
    EpicCareLinkHospitalSistersHealthSystem: 'EpicCare Link Hospital Sisters Health System',
    EpicCareLinkHurleyMedicalCenter: 'EpicCare Link Hurley Medical Center',
    EpicCareLinkIowaHealthCare: 'EpicCare Link Iowa Health Care',
    EpicCareLinkIntegrisHealth: 'EpicCare Link Integris Health',
    EpicCareLinkJupiterMedicalCenter: 'EpicCare Link Jupiter Medical Center',
    EpicCareLinkKaiserPermanente: 'EpicCare Link Kaiser Permanente',
    EpicCareLinkKingsDaughtersHealthSystem: 'EpicCare Link King\'s Daughters Health System',
    EpicCareLinkLegacyHealthyPlanet: 'EpicCare Link Legacy Healthy Planet',
    EpicCareLinkMHealthFairview: 'EpicCare Link M Health Fairview',
    EpicCareLinkMainLineHealth: 'EpicCare Link Main Line Health',
    EpicCareLinkMayoClinic: 'EpicCare Link Mayo Clinic',
    EpicCareLinkMercy: 'EpicCare Link Mercy',
    EpicCareLinkMethodistHospitals: 'EpicCare Link Methodist Hospitals',
    EpicCareLinkMethodistHealthSystem: 'EpicCare Link Methodist Health System',
    EpicCareLinkMiddlesexHealth: 'EpicCare Link Middlesex Health',
    EpicCareLinkMyMichiganHealth: 'EpicCare Link MyMichigan Health',
    EpicCareLinkNortonHealthcare: 'EpicCare Link Norton Healthcare',
    EpicCareLinkNorthMemorialHealth: 'EpicCare Link North Memorial Health',
    EpicCareLinkOchsnerHealthNetwork: 'EpicCare Link Ochsner Health Network',
    EpicCareLinkOhioHealth: 'EpicCare Link OhioHealth',
    EpicCareLinkOklahomaHeartHospital: 'EpicCare Link Oklahoma Heart Hospital',
    EpicCareLinkOsfHealthCare: 'EpicCare Link OSF HealthCare',
    EpicCareLinkOwensboroHealth: 'EpicCare Link Owensboro Health',
    EpicCareLinkPiedmont: 'EpicCare Link Piedmont',
    EpicCareLinkProvidence: 'EpicCare Link Providence',
    EpicCareLinkProvidenceWashington: 'EpicCare Link Providence Washington',
    EpicCareLinkSaintFrancis: 'EpicCare Link Saint Francis',
    EpicCareLinkShannonHealth: 'EpicCare Link Shannon Health',
    EpicCareLinkStElizabethHealthcare: 'EpicCare Link St. Elizabeth Healthcare',
    EpicCareLinkStormontVailHealth: 'EpicCare Link Stormont Vail Health',
    EpicCareLinkSsmHealth: 'EpicCare Link SSM Health',
    EpicCareLinkTexasHealth: 'EpicCare Link Texas Health',
    EpicCareLinkTheQueensHealthSystem: 'EpicCare Link The Queen\'s Health System',
    EpicCareLinkThedaCare: 'EpicCare Link ThedaCare',
    EpicCareLinkTriHealth: 'EpicCare Link TriHealth',
    EpicCareLinkTrinityHealth: 'EpicCare Link Trinity Health',
    EpicCareLinkUcHealth: 'EpicCare Link UCHealth',
    EpicCareLinkUncHealth: 'EpicCare Link UNC Health',
    EpicCareLinkUConnHealth: 'EpicCare Link UConn Health',
    EpicCareLinkUnityPointHealth: 'EpicCare Link UnityPoint Health',
    EpicCareLinkUniversityOfCincinnati: 'EpicCare Link University of Cincinnati',
    EpicCareLinkUniversityOfKansas: 'EpicCare Link University of Kansas',
    EpicCareLinkUniversityOfKansasStFrancis: 'EpicCare Link University of Kansas St Francis',
    EpicCareLinkUniversityOfMarylandMedicalSystem: 'EpicCare Link University of Maryland Medical System',
    EpicCareLinkUniversityOfMississippiMedicalCenter: 'EpicCare Link University of Mississippi Medical Center',
    EpicCareLinkUniversityHealth: 'EpicCare Link University Health',
    EpicCareLinkUniversityOfUtah: 'EpicCare Link University of Utah',
    EpicCareLinkUpmcPinnacle: 'EpicCare Link UPMC Pinnacle',
    EpicCareLinkSouthShoreHealth: 'EpicCare Link South Shore Health',
    EpicCareLinkStLukes: 'EpicCare Link St. Luke\'s',
    EpicCareLinkPremierHealth: 'EpicCare Link Premier Health',
    EpicCareLinkUtHealthEastTexas: 'EpicCare Link UT Health East Texas',
    EpicCareLinkUtSouthwesternMedicalCenter: 'EpicCare Link UT Southwestern Medical Center',
    EpicCareLinkVitruvianHealth: 'EpicCare Link Vitruvian Health',
    EpicCareLinkWellstar: 'EpicCare Link Wellstar',
    EpicCareLinkKetteringHealth: 'EpicCare Link Kettering Health',
    EpicCareLinkOlmstedMedicalCenter: 'EpicCare Link Olmsted Medical Center',
    EpicCareLinkFranciscanHealth: 'EpicCare Link Franciscan Health',
    EpicCareLinkMohawkValleyHealthSystem: 'EpicCare Link Mohawk Valley Health System',
    EpicCareLinkGeisinger: 'EpicCare Link Geisinger',
    EpicCareLinkJpsHealthNetwork: 'EpicCare Link JPS Health Network',
    EpicCareLinkPortneuf: 'EpicCare Link Portneuf',
    EpicCareLinkCheyenneRegionalMedicalCenter: 'EpicCare Link Cheyenne Regional Medical Center',
    EpicCareLinkUniversityMedicalCenter: 'EpicCare Link University Medical Center',
    EpicCareLinkCapeFearValley: 'EpicCare Link Cape Fear Valley',
    Fax: 'Fax',
    ManualUpload: 'Manual Upload',
    ManualCopy: 'Manual Copy',
    Repisodic: 'Repisodic',
    WellSkyIntake: 'WellSky Intake',
    WellSkyIntakeCarePortQuickCase: 'WellSky Intake CarePort QuickCase',
    WellSkyCarePortReferralIntake: 'WellSky CarePort Referral Intake',
    WellSkyReferralManagement: 'WellSky Referral Management',
    WellSkyReferralManagementWebReferral: 'WellSky Referral Management Web Referral',
    FourNext: 'Four Next'
} as const;
export type FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadConnectorEnum = typeof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadConnectorEnum[keyof typeof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadConnectorEnum];


/**
 * Check if a given object implements the FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead interface.
 */
export function instanceOfFindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSON(json: any): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead {
    return FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_received_date': !exists(json, 'lead_received_date') ? undefined : json['lead_received_date'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'source_name': !exists(json, 'source_name') ? undefined : json['source_name'],
        'status_id': !exists(json, 'status_id') ? undefined : json['status_id'],
        'connector': !exists(json, 'connector') ? undefined : json['connector'],
        'status': !exists(json, 'status') ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusFromJSON(json['status']),
        'waitlist': !exists(json, 'waitlist') ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistFromJSON(json['waitlist']),
        'admission_status': !exists(json, 'admission_status') ? undefined : AdmissionStatusFromJSON(json['admission_status']),
        'screener_lead_info': !exists(json, 'screener_lead_info') ? undefined : CreateLeadInfoRequestFromJSON(json['screener_lead_info']),
        'facility': !exists(json, 'facility') ? undefined : FindAllSourceTags200ResponseDataInnerFromJSON(json['facility']),
        'external_ehr_patient': !exists(json, 'external_ehr_patient') ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientFromJSON(json['external_ehr_patient']),
    };
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSON(value?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_received_date': value.lead_received_date,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'source_name': value.source_name,
        'status_id': value.status_id,
        'connector': value.connector,
        'status': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusToJSON(value.status),
        'waitlist': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistToJSON(value.waitlist),
        'admission_status': AdmissionStatusToJSON(value.admission_status),
        'screener_lead_info': CreateLeadInfoRequestToJSON(value.screener_lead_info),
        'facility': FindAllSourceTags200ResponseDataInnerToJSON(value.facility),
        'external_ehr_patient': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientToJSON(value.external_ehr_patient),
    };
}

